import React from "react";
import PropTypes from "prop-types";

import HeaderContainer from "./HeaderContainer";

const Header = ({ className, children, fluid, ...props }) => (
  <HeaderContainer className={className} fluid={fluid} {...props}>
    <div className="d-flex align-items-center justify-content-between">
      {children}
    </div>
  </HeaderContainer>
);

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fluid: PropTypes.bool
};

Header.defaultProps = {
  className: "",
  children: null,
  fluid: true
};

export default Header;
